module.exports = __webpack_public_path__ + "coin_USDT.png?a476e8e079f144e65e714f8d6be5c435";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/coin_USDT.png
// module id = 29
// module chunks = 2